/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Config } from '../../config'
import { makeRequest } from '../../common/index'
// import qs from 'qs'

const base_url = Config.admin.api_base_url
const context = Config.services.context
const endpoint = `/${context}/permit`

/**
 * getPermit
 * 
 * @param token
 * @param permit_id
 * @returns {Promise<*|void>}
 */
const getPermit = async function (token, permit_id) {
    const method = "GET"
    let path = `${endpoint}/${permit_id}`
    const headers = { Authorization: `Bearer ${token}` }
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * searchPermit
 * 
 * @param token
 * @param payload
 * @returns {Promise<*|void>}
 */
const searchPermit = async function (token, payload) {
    const method = "POST"
    let path = `${endpoint}/search`
    const headers = { Authorization: `Bearer ${token}` }
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * searchPermitNumber
 *
 * @param token
 * @param payload
 * @returns {Promise<*|void>}
 */
const searchPermitNumber = async function (token, payload) {
    const method = "POST"
    let path = `${endpoint}/autocomplete`
    const headers = { Authorization: `Bearer ${token}` }
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * myPermits
 *
 * @param token
 * @param payload
 * @returns {Promise<*|void>}
 */
const myPermits = async function (token, payload) {
    const method = "POST"
    let path = `${endpoint}/my`
    const headers = { Authorization: `Bearer ${token}` }
    return await makeRequest(method, base_url, path, headers, payload)
}

export {
    getPermit,
    searchPermit,
    searchPermitNumber,
    myPermits
}
